import InputField from 'components/InputField';
import Properties from 'components/Properties';
// import Select from 'components/Select';
import { Input, InputNumber, Select } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { getAttributes } from 'services/audience_management';
import './index.css';
import { create_Audience, getAttributeValues } from 'services/ManageCustomerBase';
import { CustomerBase } from 'config';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import useRouter from 'hooks/useRouter';
import checkPermissionFunction from 'Permission';
import {
  DEFAULT_MIN_STAY_TIME,
  STAY_TIME_MAX_SECONDS,
  describeStayTime,
  getStayTimeErrors,
} from './stayTime';

const AddCustomerBase = () => {
  const path = 'AddCustomerBase';

  const router = useRouter();

  const [chooseFile, set_choose_file] = useState(1);
  const [numberClickAnd, setNumberClickAnd] = useState([1]);
  const [Attributes, setAttributes] = useState([]);
  const [attributeValues, set_attributeValues] = useState({});
  const [selectProperties, setSelectProperties] = useState({});

  const [management, setManagement] = useState({});
  const [submanagement, setSubManagement] = useState({});
  const [showmanagement, setShowManagement] = useState({});

  const [name_audience, set_name_audience] = useState('');
  const [description, set_description] = useState('');
  const [firebaseTopic, set_firebaseTopic] = useState(2);
  const [status, set_status] = useState(1);
  const [customize_type, set_customize_type] = useState(1);
  // Thời gian ở tập, đơn vị giây. min mặc định 0 (không giữ chỗ), max null = vô hạn.
  const [min_stay_time, set_min_stay_time] = useState(DEFAULT_MIN_STAY_TIME);
  const [max_stay_time, set_max_stay_time] = useState(null);
  const [CustomerBase_Type, set_CustomerBase_Type] = useState([]);
  const [CustomerBase_Status, set_CustomerBase_Status] = useState([]);

  const [err, set_err] = useState({});
  useEffect(() => {
    async function freshData() {
      const value = await getAttributes();
      setAttributes(value.data.data);
      set_CustomerBase_Type(CustomerBase.type.filter((item) => item.id != 0));
      set_CustomerBase_Status(CustomerBase.status.filter((item) => item.id != 0));
    }
    freshData();
  }, []);

  async function getValues(id) {
    if (
      !(id in attributeValues) ||
      attributeValues[id] == undefined ||
      !attributeValues[id] == null
    ) {
      const value = await getAttributeValues(id);
      let obj = Object.assign({}, attributeValues);
      obj[id] = value.data.data;
      set_attributeValues(obj);
    }
  }

  // useEffect(() => {
  //     console.log(management);
  // }, [management]);

  function Notifire(text) {
    Swal.fire({
      title: t('Notification'),
      text: `${text} không được để trống`,
      icon: 'warning',
      confirmButtonText: t('Yes'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
      },
    });
  }

  async function OnSave() {
    if (name_audience == '') {
      const error = Object.assign({}, err);
      error.name = 'Chưa nhập tên khách hàng';
      set_err(error);
      return;
    } else {
      const error = Object.assign({}, err);
      delete error.name;
      set_err(error);
    }

    const stayTimeErrors = getStayTimeErrors({
      minStayTime: min_stay_time,
      maxStayTime: max_stay_time,
    });
    if (Object.keys(stayTimeErrors).length) {
      set_err(Object.assign({}, err, stayTimeErrors));
      return;
    }
    set_err((error) => {
      const next = Object.assign({}, error);
      delete next.minStayTime;
      delete next.maxStayTime;
      return next;
    });

    var formData = new FormData();

    if (name_audience.trim().length > 500) {
      const error = Object.assign({}, err);
      error.name = 'Tên tập khách hàng có độ dài <= 500';
      set_err(error);
      return;
    }

    formData.append('name', name_audience);
    formData.append('description', description);
    formData.append('type', chooseFile);
    formData.append('firebaseTopic', firebaseTopic || 1);
    formData.append('minStayTime', min_stay_time ?? DEFAULT_MIN_STAY_TIME);
    // Bỏ trống ô tối đa = vô hạn, không gửi trường lên để server dùng đúng mặc định của cột
    if (max_stay_time != null) {
      formData.append('maxStayTime', max_stay_time);
    }

    if (chooseFile == 1) {
      var file = document.getElementById('file').files[0];
      if (file != undefined && file != null) {
        formData.append('file', file);
      }
    } else {
      if (status == '') {
        Notifire('Trạng thái');
        return;
      }
      formData.append('status', status || 1);

      let values = Object.keys(management).map((item1) => {
        let values1 = Object.keys(management[item1]).map((item2) => {
          let values2 = Object.keys(management[item1][item2]).map((item3) => {
            return management[item1][item2][item3];
          });
          const sub_attribute = submanagement?.[item1]?.[item2];
          return values2.length === 1
            ? { ...values2[0], sub_attribute: sub_attribute }
            : { op: 'or', value: values2, sub_attribute: sub_attribute };
        });
        return values1.length === 1 ? values1[0] : { op: 'or', value: values1 };
      });
      if (values.length == 0) {
        Swal.fire({
          title: t('Notification'),
          text: 'Vui lòng nhập đầy đủ thông tin',
          icon: 'warning',
          confirmButtonText: t('Yes'),
          customClass: {
            confirmButton: 'btn btn-danger font-weight-bolder',
          },
        });
        return;
      }
      let obj = values.length === 1 ? values[0] : { op: 'and', value: values };
      console.log(obj);
      console.log('a: ', JSON.stringify(obj));
      // console.log(management);
      formData.append('condition', JSON.stringify(obj));
      formData.append('subAttribute', JSON.stringify(submanagement));
      formData.append('conditionValue', JSON.stringify(management));
      formData.append('showCondition', JSON.stringify(showmanagement));
      formData.append('customizeType', customize_type || 1);
    }

    try {
      const res = await create_Audience(formData);
      if (res.data.status == 1) {
        await Swal.fire({
          title: t('Notification'),
          text: 'Thêm tập khách hàng thành công',
          icon: 'success',
          confirmButtonText: t('Yes'),
          customClass: {
            confirmButton: 'btn btn-danger font-weight-bolder',
          },
        }).then(async function (result) {
          if (result.value) {
            router.navigate('/LichViet/CustomerSet');
          }
        });
      } else {
        Swal.fire({
          title: t('Notification'),
          text: res.showMessage ?? 'Thêm tập khách hàng thất bại',
          icon: 'success',
          confirmButtonText: t('Yes'),
          customClass: {
            confirmButton: 'btn btn-danger font-weight-bolder',
          },
        });
      }
      return;
    } catch (err) {
      Swal.fire({
        title: t('Notification'),
        text: err.response?.data?.showMessage ?? 'Thêm tập khách hàng thất bại',
        icon: 'warning',
        confirmButtonText: t('Yes'),
        customClass: {
          confirmButton: 'btn btn-danger font-weight-bolder',
        },
      });
    }
  }

  return (
    <div className="container-fluid">
      <div className="bg-white card pt-5">
        <div className="card-header border-0 pt-6 pb-0">
          <div className="w-100 d-flex justify-content-between">
            <div className="card-title my-0">
              <h3 className="card-label">
                <b>THÊM TẬP KHÁCH HÀNG</b>{' '}
              </h3>
            </div>
          </div>
        </div>
        <div className="card-body py-3 d-flex flex-column min-h-100 gap-4">
          <div>
            <div className="row">
              <div className="col-sm">
                <div>Tên tập khách hàng (*)</div>
                <Input
                  placeholder="Tên tập khách hàng"
                  style={{ width: '400px' }}
                  onChange={(e) => set_name_audience(e.target.value)}
                />
                {err?.name && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{err?.name}</div>
                  </div>
                )}
              </div>
              <div className="col-sm flex justify-end">
                <div>
                  <div>Loại tập khách hàng (*)</div>
                  <Select
                    defaultValue={CustomerBase.type.find((item) => item.id == 1)?.name}
                    disabled={true}
                    style={{
                      width: '400px',
                    }}
                    onChange={(e) => set_choose_file(e)}
                    options={CustomerBase_Type.map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>Mô tả</div>
            <Input
              placeholder="Nhập mô tả"
              // style={{ width: '400px' }}
              onChange={(e) => {
                set_description(e.target.value);
              }}
            />
          </div>
          <div>
            <div className="row">
              <div className="col-sm">
                <div>Thời gian ở tập tối thiểu (giây)</div>
                <InputNumber
                  className="w-100"
                  placeholder="0"
                  min={0}
                  max={STAY_TIME_MAX_SECONDS}
                  step={60}
                  precision={0}
                  value={min_stay_time}
                  onChange={(value) => set_min_stay_time(value)}
                />
                <div className="text-muted" style={{ fontSize: '12px' }}>
                  Chưa ở đủ thời gian này thì khách không bị kích ra khỏi tập. Để trống hoặc 0 =
                  không giữ chỗ. {describeStayTime(min_stay_time)}
                </div>
                {err?.minStayTime && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{err?.minStayTime}</div>
                  </div>
                )}
              </div>
              <div className="col-sm">
                <div>Thời gian ở tập tối đa (giây)</div>
                <InputNumber
                  className="w-100"
                  placeholder="Để trống = vô hạn"
                  min={1}
                  max={STAY_TIME_MAX_SECONDS}
                  step={60}
                  precision={0}
                  value={max_stay_time}
                  onChange={(value) => set_max_stay_time(value)}
                />
                <div className="text-muted" style={{ fontSize: '12px' }}>
                  Khách không được ở trong tập quá thời gian này. Để trống = vô hạn.{' '}
                  {describeStayTime(max_stay_time)}
                </div>
                {err?.maxStayTime && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{err?.maxStayTime}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {chooseFile == 1 ? (
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Tải file khách hàng (.csv, .xlsx, .xls)
              </label>
              <input
                className="block w-full text-lg text-gray-900 border border-gray-300 rounded-sm cursor-pointer focus:outline-none"
                type="file"
                accept=".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                id="file"
              // onChange={(e) => {
              //     const file = e.target.files[0];
              //     const formData = new FormData();
              //     formData.append("file", file);
              //     console.log(formData);
              // }}
              />
              {err?.file && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{err?.file}</div>
                </div>
              )}
              <a href="/data.xlsx" download>
                Tải xuống file Excel mẫu
              </a>
            </div>
          ) : (
            <div className="flex flex-col gap-3">
              <label>Danh sách thuộc tính lọc</label>
              {numberClickAnd.map((item, i) => (
                <Fragment key={i}>
                  <div className="border-1 gap-3" key={i}>
                    <Properties
                      property={Attributes}
                      change={(item) => {
                        if (item.length == 0) {
                          let data = [...numberClickAnd];
                          data.splice(i, 1);
                          setNumberClickAnd(data);
                        }
                      }}
                      indexId={i}
                      attributeChange={(item) => {
                        getValues(item);
                        let obj = Object.assign({}, selectProperties);
                        obj[i] = item;
                        setSelectProperties(obj);
                      }}
                      option={attributeValues[selectProperties[i]]}
                      onChange={(item) => {
                        let obj = Object.assign({}, management);
                        if (isEmpty(item)) {
                          delete obj[i];
                          setManagement(obj);
                        } else {
                          obj[i] = item;
                          setManagement(obj);
                        }
                      }}
                      onChangeSub={(item) => {
                        let obj = Object.assign({}, submanagement);
                        if (isEmpty(item)) {
                          delete obj[i];
                          setSubManagement(obj);
                        } else {
                          obj[i] = item;
                          setSubManagement(obj);
                        }
                      }}
                      onChangeShow={(item) => {
                        let obj = Object.assign({}, showmanagement);
                        if (isEmpty(item)) {
                          delete obj[i];
                          setShowManagement(obj);
                        } else {
                          obj[i] = item;
                          setShowManagement(obj);
                        }
                      }}
                    />
                  </div>
                  {i != numberClickAnd.length - 1 && <span>AND</span>}
                </Fragment>
              ))}
              <div>
                <div
                  className="btn btn-primary"
                  onClick={() => {
                    let data = [...numberClickAnd];
                    data.push(Math.max(...numberClickAnd) + 1);
                    setNumberClickAnd(data);
                  }}
                >
                  AND
                </div>
              </div>
            </div>
          )}
          <div>
            <div className="row">
              <div className="col-sm flex flex-col">
                <div>Push notification</div>
                <Select
                  defaultValue={
                    CustomerBase.Firebase_Topic.find((item) => item.id == firebaseTopic)?.name
                  }
                  style={{
                    width: '100%',
                  }}
                  onChange={(e) => set_firebaseTopic(e)}
                  options={CustomerBase.Firebase_Topic.map((item) => {
                    return { label: item.name, value: item.id };
                  })}
                />
              </div>
              <div className="col-sm flex flex-col justify-end">
                {chooseFile == 2 && (
                  <div>
                    <div>customize_type (*)</div>
                    <Select
                      defaultValue={
                        CustomerBase.customize_type.find((item) => item.id == customize_type)?.name
                      }
                      style={{
                        width: '100%',
                      }}
                      onChange={(e) => set_customize_type(e)}
                      options={CustomerBase.customize_type.map((item) => {
                        return { label: item.name, value: item.id };
                      })}
                    />
                  </div>
                )}
              </div>
              {chooseFile == 2 && (
                <div className="col-sm flex flex-col justify-end">
                  <div>Trạng thái (*)</div>
                  <Select
                    defaultValue={CustomerBase.status.find((item) => item.id == status)?.name}
                    style={{
                      width: '100%',
                    }}
                    onChange={(e) => set_status(e)}
                    options={CustomerBase_Status.map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                  />
                </div>
              )}
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-sm"></div>
              <div className="col-sm">
                <div className="d-flex justify-content-end gap-5">
                  <span
                    className="btn btn-bg-secondary"
                    onClick={() => {
                      router.navigate('/LichViet/CustomerSet');
                    }}
                  >
                    Hủy
                  </span>
                  <span
                    className="btn btn-primary"
                    onClick={() => {
                      OnSave();
                    }}
                  >
                    Lưu
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddCustomerBase;
